"use client";

import React from "react";
import { ArrowRight, Layers, MessageCircle, Server, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EMillenniumRealOmnichannelManagement() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    icon: Layers,
    title: "Omnichannel Nativo",
    desc: "Integração total de canais"
  }, {
    icon: Server,
    title: "WMS Avançado",
    desc: "Gestão de estoque em tempo real"
  }, {
    icon: TrendingUp,
    title: "Alta Escalabilidade",
    desc: "Para grandes volumes de pedidos"
  }];
  return <section id="e-millennium-gestão-omnichannel-real" className="dark bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592892/img/emillennium_omnichannel_tech_hero.png)] bg-cover bg-center bg-no-repeat opacity-30 mix-blend-luminosity" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/95 to-background/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
      </div>

      {}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-primary/5 blur-[120px] rounded-full pointer-events-none z-0" />
      <div className="absolute bottom-0 left-1/4 w-1/3 h-1/2 bg-primary/10 blur-[100px] rounded-full pointer-events-none z-0" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
        <div ref={ref} className={`max-w-3xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-semibold tracking-wide mb-6">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
            ERP PARA ATACADO, INDÚSTRIA E E-COMMERCE
          </div>

          {}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-white mb-6 leading-[1.1]">
            Gestão Omnichannel Real com <span className="!text-primary">e-Millennium</span>
          </h1>

          {}
          <p className="text-lg sm:text-xl text-muted-foreground mb-10 max-w-2xl leading-relaxed">
            Escale sua operação com o ERP líder em WMS, integração de marketplaces e alta performance. A tecnologia definitiva para transformar a complexidade do seu negócio em resultados previsíveis.
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <Button size="lg" className="text-base h-14 px-8" asChild>
              <Link to="/ContactsPage">
                Solicitar Demonstração
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="text-base h-14 px-8 border-border hover:bg-white/5" asChild>
              <Link to="https://api.whatsapp.com/send?phone=5527992826653&text=Bem%20vindo%20a%20Franquia%20Linx%20Vila%20Velha." newTab>
                <MessageCircle className="mr-2 size-5 text-[#25D366]" />
                Falar no WhatsApp
              </Link>
            </Button>
          </div>

          {}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-8 border-t border-border/50">
            {features.map((feature, i) => <div key={i} data-index={i} className="card p-6 rounded-xl border border-white/5 flex flex-col gap-4 transition-all hover:border-primary/30">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center border border-primary/20">
                  <feature.icon className="size-6 !text-primary" />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-base mb-1">{feature.title}</h3>
                  <p className="text-sm text-muted-foreground">{feature.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}